import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useModalRouter from 'hooks/useModalRouter';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faCodeCompare } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import CompareRoleModal from './CompareRoleModal';

/**
 * @author Burak Unsal
 */
const AccessControl = () => {
	const { showModal } = useModalRouter();

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{ Header: 'Path', accessor: 'path', filterType: FilterType.string, width: 200 },
			{
				Header: 'Roles',
				accessor: 'roles',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ROLE_NAMES,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200,
				showOnMobile: true
			},
			{
				Header: 'Modules',
				accessor: 'modules',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ROLE_NAMES,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200,
				showOnMobile: true
			},
			{
				Header: 'Disable if module exists',
				accessor: 'disableModules',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ROLE_NAMES,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200
			},
			{
				Header: 'Packages',
				accessor: 'packageRoleIds',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ROLE_NAMES,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200
			},
			{
				Header: 'Countries',
				accessor: 'enabledCountries',
				filterType: FilterType.string,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200
			},
			{
				Header: 'clients',
				accessor: 'clients',
				filterType: FilterType.string,
				renderCell: ListComponents.TEXT_ARRAY,
				width: 200
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<div>
			<PageHeader title="accessControl">
				<Button
					icon={faCodeCompare}
					label="compareRoles"
					onClick={() => {
						NiceModal.show(CompareRoleModal);
					}}
				/>
				<Button icon={faPlus} label="addActionRole" onClick={() => showModal('action-role-modal')} />
				<Button icon={faPlus} label="add" onClick={() => showModal('role-modal')} />
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.ACCESS_CONTROL}
				columns={columns}
				defaultSort={defaultSort}
				fetchUrl={ADMIN.ROLE.GET_ROLES_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</div>
	);
};

export default AccessControl;
